import { BasicAsyncEnumerable } from "../BasicAsyncEnumerable.js";
export const unionAsync = (first, second, comparer) => {
    async function* iterator() {
        const result = [];
        for (const source of [first, second]) {
            for await (const value of source) {
                let exists = false;
                for (const resultValue of result) {
                    if (await comparer(value, resultValue) === true) {
                        exists = true;
                        break;
                    }
                }
                if (exists === false) {
                    yield value;
                    result.push(value);
                }
            }
        }
    }
    return new BasicAsyncEnumerable(iterator);
};
